import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Typography from '@mui/material/Typography';
import flaskServer from '../config/flaskserver';
import StyledButton from '../layout/StyledButton';

function RelatorioComponente({ option = 'historico' }) {
    const [colunasDisponiveis, setColunasDisponiveis] = useState([]);
    const [colunasSelecionadas, setColunasSelecionadas] = useState([]);
    const [formatoRelatorio, setFormatoRelatorio] = useState('');
    const [valoresFiltro, setValoresFiltro] = useState({});
    const [filtrosSelecionados, setFiltrosSelecionados] = useState({});

    useEffect(() => {
        async function fetchColunasDisponiveis() {
            try {
                const token = localStorage.getItem('token');
                console.log(`[Relatorio] Fetching columns for option: ${option}`);
                const response = await axios.post(`${flaskServer.flaskServerIP}/colunas_disponiveis`, {
                    opcao: option
                }, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                console.log('[Relatorio] Columns response:', response.data);
                setColunasDisponiveis(response.data.colunas || []);
                if (response.data.colunas && response.data.colunas.length > 0) {
                    fetchDistinctValues(response.data.colunas);
                }
            } catch (error) {
                console.error('Erro ao obter colunas disponíveis:', error);
            }
        }
        fetchColunasDisponiveis();
    }, [option]);

    const fetchDistinctValues = async (colunas) => {
        try {
            const token = localStorage.getItem('token');
            console.log(`[Relatorio] Fetching distinct values for ${colunas.length} columns`);
            const response = await axios.post(`${flaskServer.flaskServerIP}/distinct_values`, {
                opcao: option,
                colunas
            }, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            console.log('[Relatorio] Distinct values response:', response.data);
            setValoresFiltro(response.data.valores_distintos || {});
        } catch (error) {
            console.error('Erro ao obter valores distintos:', error);
        }
    };

    const handleToggle = (value) => () => {
        const currentIndex = colunasSelecionadas.indexOf(value);
        const newChecked = [...colunasSelecionadas];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setColunasSelecionadas(newChecked);
    };

    const handleFiltroChange = (coluna) => (event) => {
        setFiltrosSelecionados({
            ...filtrosSelecionados,
            [coluna]: event.target.value
        });
    };

    const handleFormatoChange = (event) => {
        setFormatoRelatorio(event.target.value);
    };

    const handleGerarRelatorio = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.post(`${flaskServer.flaskServerIP}/gerar_relatorio`, {
                colunas: colunasSelecionadas,
                formato: formatoRelatorio,
                opcao: option,
                filtros: filtrosSelecionados
            }, {
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `relatorio.${formatoRelatorio}`);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.error('Erro ao gerar relatório:', error);
        }
    };

    const handleSelectAll = () => {
        setColunasSelecionadas([...colunasDisponiveis]);
    };

    const handleClearAll = () => {
        setColunasSelecionadas([]);
        setFiltrosSelecionados({});
    };

    return (
        <Grid container spacing={2} justifyContent="center">
            <Grid item xs={12}>
                <Typography variant="h5" gutterBottom>Gerador de Relatórios</Typography>
            </Grid>
            <Grid item>
                <Paper sx={{ width: 250, height: 300, overflow: 'auto', padding: '10px' }}>
                    <List dense component="div" role="list">
                        <ListItemButton>
                            <ListItemText primary="Colunas Disponíveis" />
                        </ListItemButton>
                        {colunasDisponiveis.map((value) => (
                            <ListItemButton
                                key={value}
                                role="listitem"
                                onClick={handleToggle(value)}
                            >
                                <ListItemIcon>
                                    <Checkbox
                                        checked={colunasSelecionadas.indexOf(value) !== -1}
                                        tabIndex={-1}
                                        disableRipple
                                    />
                                </ListItemIcon>
                                <ListItemText primary={value} />
                            </ListItemButton>
                        ))}
                    </List>
                </Paper>
                <Button onClick={handleSelectAll} sx={{ mt: 2 }}>Selecionar Todas</Button>
            </Grid>
            <Grid item>
                <Grid container direction="column" alignItems="center" spacing={2}>
                    <Grid item>
                        <FormControl sx={{ minWidth: 120 }}>
                            <InputLabel id="formato-relatorio-label">Tipo</InputLabel>
                            <Select
                                labelId="formato-relatorio-label"
                                id="formato-relatorio"
                                value={formatoRelatorio}
                                onChange={handleFormatoChange}
                            >
                                <MenuItem value="xlsx">Excel</MenuItem>
                                <MenuItem value="txt">TXT</MenuItem>
                                <MenuItem value="csv">CSV</MenuItem>
                                <MenuItem value="xml">XML</MenuItem>
                                <MenuItem value="html">HTML</MenuItem>
                                <MenuItem value="pdf">PDF</MenuItem>
                                {/* Add more options as needed */}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item>
                        <StyledButton variant="contained" onClick={handleGerarRelatorio}>
                            Gerar Relatório
                        </StyledButton>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item>
                <Paper sx={{ width: 250, height: 300, overflow: 'auto', padding: '10px' }}>
                    <List dense component="div" role="list">
                        <ListItemButton>
                            <ListItemText primary="Colunas Selecionadas" />
                        </ListItemButton>
                        {colunasSelecionadas.map((value) => (
                            <ListItemButton
                                key={value}
                                role="listitem"
                                onClick={handleToggle(value)}
                            >
                                <ListItemIcon>
                                    <Checkbox
                                        checked={colunasSelecionadas.indexOf(value) !== -1}
                                        tabIndex={-1}
                                        disableRipple
                                    />
                                </ListItemIcon>
                                <ListItemText primary={value} />
                            </ListItemButton>
                        ))}
                    </List>
                </Paper>
                <Button onClick={handleClearAll} sx={{ mt: 2 }}>Limpar Seleção</Button>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                    Filtros
                </Typography>
                {colunasDisponiveis.map((coluna) => (
                    <Grid item xs={12} key={coluna}>
                        <FormControl fullWidth>
                            <InputLabel>{`Valores para ${coluna}`}</InputLabel>
                            <Select
                                multiple
                                value={filtrosSelecionados[coluna] || []}
                                onChange={handleFiltroChange(coluna)}
                                renderValue={(selected) => selected.join(', ')}
                            >
                                {(valoresFiltro[coluna] || []).map((valor) => (
                                    <MenuItem key={valor} value={valor}>
                                        {valor}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                ))}
            </Grid>
        </Grid>
    );
}

export default RelatorioComponente;
